// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"policy_checkbox_checkboxContainer__1rRtb","policyText":"policy_checkbox_policyText__-maly"};